module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('NbBtnDropdown', {
    attrs: {
      "name": _vm.current.name,
      "size": "sm",
      "color": _vm.currentStyle
    }
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.select(-1)
      }
    }
  }, [_vm._v("所有")])]), _vm._v(" "), _vm._l((_vm.filter.options), function(option, index) {
    return _c('li', [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.select(index)
        }
      }
    }, [_vm._v(_vm._s(option.name))])])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-1cc1c703"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/common/widget/filter/NbFilterSelection.vue
// module id = 955
// module chunks = 1